import React, { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Card,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Switch,
  TextField,
  useTheme
} from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import axiosConfig from '../../../Resources/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios/index';
import routes from '../../../Resources/routes.json';
import { useNavigate } from 'react-router-dom';
import { TokenContext } from '../../../contexts/tokenContext';
import { Action } from '../../../interfaces/S3Types';
import Button from '@mui/material/Button';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { UserContext } from '../../../contexts/userContext';

dayjs.extend(utc);
dayjs.extend(timezone);

interface HistoryProps {
  errorLoadingS3Data: boolean;
  id: number;
}

function HistoryOfActions(props: HistoryProps) {
  const theme = useTheme();
  const searchParams = new URLSearchParams(location.search);
  const [history, setHistory] = useState<Action[]>([]);
  const navigate = useNavigate();
  const tokencontext = useContext(TokenContext);
  const [actionDate, setActionDate] = useState(dayjs());
  const { removeToken } = tokencontext;
  const [openModalAddAction, setOpenModalAddAction] = useState(false);

  const requiredFields = ['description', 'timestamp'];
  const [newAction, setNewAction] = useState<Partial<Action>>({
    installationId: props.id,
    timestamp: actionDate.toDate(),
    description: '',
    testingMode: false
  });
  const context = useContext(UserContext);
  const { currentUser, setUser } = context;
  const [isRowHovered, setHoveredRow] = useState(-1);
  const [selectedAction, setSelectedAction] = useState<number>(-1);
  const [editMode, setEditMode] = useState(false);
  const handleDateChange = (newdate) => {
    setActionDate(newdate);
    setNewAction({
      ...newAction,
      ['timestamp']: newdate
    });
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setNewAction({
      ...newAction,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const resetNewAction = () => {
    console.log('Reset action to default');
    setActionDate(dayjs());
    setNewAction({
      ...newAction,
      ['description']: '',
      ['timestamp']: dayjs().toDate()
    });
    setEditMode(false);
  };

  const handleAddActionButton = () => {
    resetNewAction();
    setOpenModalAddAction(true);
  };

  const handleEdit = (action) => {
    setEditMode(true);
    setNewAction(action);
    setOpenModalAddAction(true);
  };

  const SumbitNewAction = async () => {
    const endpoint = editMode ? `/UpdateAction` : `/InsertNewAction`;
    //console.log('Add an action', endpoint);
    const res = await axiosConfig.post(endpoint, newAction).catch((err) => {
      if (err.response) {
      }
    });

    if (res) {
      getHistory();
      setOpenModalAddAction(false);
      setEditMode(false);
    }
  };

  const deleteUserModalHandleCancel = (e) => {
    setOpenModalAddAction(false);
    setEditMode(false);
  };

  const HandleDelete = async (action) => {
    const res = await axiosConfig
      .post(`/DeleteAction?actionId=${action.id}`)
      .catch((err) => {
        if (err.response) {
        }
      });

    if (res) {
      getHistory();
    }
  };

  const areRequiredFieldsFilled = () => {
    for (const field of requiredFields) {
      if (!newAction[field]) {
        return false;
      }
    }
    return true;
  };

  const getHistory = () => {
    axiosConfig
      .get(`/GetHistoryForInstallation?id=${props.id}`)
      .then((res: AxiosResponse<Action[]>) => {
        setHistory(res.data);
      })
      .catch((err: AxiosError) => {
        if (err.response && err.response.status == 401) {
          removeToken();
          navigate(routes.login);
        }
      });
  };

  useEffect(() => {
    getHistory();
  }, [openModalAddAction]);

  return (
    <>
      {openModalAddAction && (
        <Modal
          open={openModalAddAction}
          aria-labelledby="error-modal"
          aria-describedby="error-modal-description"
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 500,
                bgcolor: 'background.paper',
                borderRadius: 4,
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <div>
                {/*<DateTimePicker*/}
                {/*  label="Select Action Date"*/}
                {/*  name="timestamp"*/}
                {/*  value={actionDate}*/}
                {/*  onChange={(newDate: Dayjs | null) =>*/}
                {/*    handleDateChange(newDate)*/}
                {/*  }*/}
                {/*  InputProps={{*/}
                {/*    sx: {*/}
                {/*      width: 450,*/}
                {/*      marginTop: 2*/}
                {/*    }*/}
                {/*  }}*/}
                {/*/>*/}

                <DateTimePicker
                  label="Select Action Date"
                  value={actionDate}
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: 450, marginTop: 2 }} />
                  )}
                />

                <TextField
                  label="Description"
                  variant="outlined"
                  name="description"
                  value={newAction.description}
                  onChange={handleChange}
                  fullWidth
                  multiline
                  rows={4} // Adding rows prop to make it a multiline field with more space
                  sx={{
                    marginBottom: 2,
                    marginTop: 2,
                    height: 'auto'
                  }} // 'auto' height works better with multiline fields
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      name="testingMode"
                      checked={newAction.testingMode}
                      onChange={handleChange}
                    />
                  }
                  label="Test Mode"
                />

                <Button
                  sx={{
                    marginLeft: 2,
                    textTransform: 'none',
                    bgcolor: '#ffc04d',
                    color: '#111111',
                    '&:hover': { bgcolor: '#f7b34d' }
                  }}
                  onClick={SumbitNewAction}
                  disabled={!areRequiredFieldsFilled()}
                >
                  Submit
                </Button>

                <Button
                  sx={{
                    marginLeft: 2,
                    textTransform: 'none',
                    bgcolor: '#ffc04d',
                    color: '#111111',
                    '&:hover': { bgcolor: '#f7b34d' }
                  }}
                  onClick={deleteUserModalHandleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Box>
          </LocalizationProvider>
        </Modal>
      )}

      <Container maxWidth="xl">
        <Grid container>
          <Grid container>
            <Grid item xs={6} md={6}>
              <Button
                variant="contained"
                onClick={handleAddActionButton}
                sx={{
                  marginTop: '20px',
                  backgroundColor: '#ffc04d',
                  color: '#000000',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
              >
                <FormattedMessage
                  id="add_action"
                  defaultMessage="Add New Action"
                />
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} md={12}>
            {history.length > 0 && (
              <Card sx={{ marginTop: '10px' }}>
                <Divider />
                <div>
                  <div
                    style={{
                      height: '40px',
                      marginBottom: '10px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        flex: 2,
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="dimgrey"
                        fontWeight="bold"
                        fontSize="1rem"
                        gutterBottom
                        noWrap
                      >
                        <FormattedMessage id="user" defaultMessage="User" />
                      </Typography>
                    </div>

                    <div
                      style={{
                        flex: 1,
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="dimgrey"
                        fontWeight="bold"
                        fontSize="1rem"
                        gutterBottom
                        noWrap
                      >
                        <FormattedMessage id="date" defaultMessage="Date" />
                      </Typography>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="dimgrey"
                        fontWeight="bold"
                        fontSize="1rem"
                        gutterBottom
                        noWrap
                      >
                        <FormattedMessage id="time" defaultMessage="Time" />
                      </Typography>
                    </div>
                    <div
                      style={{
                        flex: 6,
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="dimgrey"
                        fontWeight="bold"
                        fontSize="1rem"
                        gutterBottom
                        noWrap
                      >
                        <FormattedMessage
                          id="description"
                          defaultMessage="Description"
                        />
                      </Typography>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="dimgrey"
                        fontWeight="bold"
                        fontSize="1rem"
                        gutterBottom
                        noWrap
                      >
                        <FormattedMessage id="edit" defaultMessage="Edit" />
                      </Typography>
                    </div>
                  </div>
                  <Divider />
                  <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    {history.map((action, index) => {
                      // // Parse the timestamp string to a Date object
                      // const date = new Date(action.timestamp);
                      //
                      // // Extract the date part (e.g., "2023-05-31")
                      // const datePart = date.toLocaleDateString();
                      //
                      // // Extract the time part (e.g., "12:34:56")
                      // const timePart = date.toLocaleTimeString();
                      const dateCET = dayjs.utc(action.timestamp).tz("Europe/Paris");
                      const datePart = dateCET.format("YYYY-MM-DD");
                      const timePart = dateCET.format("HH:mm:ss");

                      const iconStyle =
                        action.userName === currentUser.name
                          ? {}
                          : { color: 'rgba(0, 0, 0, 0.26)' };

                      return (
                        <React.Fragment key={index}>
                          <Divider />
                          <div
                            style={{
                              minHeight: '40px',
                              marginBottom: '10px',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <div
                              style={{
                                flex: 2,
                                marginTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                color="text.primary"
                                gutterBottom
                              >
                                {action.userName}
                              </Typography>
                            </div>

                            <div
                              style={{
                                flex: 1,
                                marginTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                color="text.primary"
                                gutterBottom
                              >
                                {datePart}
                              </Typography>
                            </div>
                            <div
                              style={{
                                flex: 1,
                                marginTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                color="text.primary"
                                gutterBottom
                              >
                                {timePart}
                              </Typography>
                            </div>

                            <div
                              style={{
                                flex: 6,
                                display: 'flex',
                                marginTop: '15px',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                color="text.primary"
                                gutterBottom
                                style={{
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word'
                                }}
                              >
                                {action.description}
                              </Typography>
                            </div>

                            <div
                              style={{
                                flex: 1,
                                marginTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <IconButton
                                style={iconStyle}
                                onClick={() => handleEdit(action)}
                                disabled={action.userName != currentUser.name}
                              >
                                <EditIcon />
                              </IconButton>
                              <IconButton
                                style={iconStyle}
                                onClick={() => HandleDelete(action)}
                                // disabled={action.userName != currentUser.name}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </Card>
            )}

            {!props.errorLoadingS3Data && history.length == 0 && (
              <Alert
                severity="error"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '20px'
                }}
              >
                <FormattedMessage
                  id="nohistory"
                  defaultMessage="There is no history of actions"
                />
                <IconButton
                  color="inherit"
                  size="small"
                  sx={{ marginLeft: '4px' }}
                ></IconButton>
              </Alert>
            )}
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} style={{ marginBottom: '20px' }}>
          {props.errorLoadingS3Data && (
            <Alert
              severity="error"
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '20px'
              }}
            >
              <FormattedMessage
                id="cannotloadloggingdata"
                defaultMessage="Cannot load logging data"
              />
              <IconButton
                color="inherit"
                size="small"
                sx={{ marginLeft: '4px' }}
              ></IconButton>
            </Alert>
          )}
        </Grid>
      </Container>
    </>
  );
}

export default HistoryOfActions;
